import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { getTotem, setCidade } from '../../api/apiFactory';
import { fetchLimparCookie, fetchNomeCidade } from '../../api/endpoints';
import { definirCidade, fetchConfiguracoesCidade, selectCidade } from '../../app/slices/cidadesSlice';
import { desfazerConexao, selectLogin } from '../../app/slices/loginSlice';
import { resetarModais, selectModal } from '../../app/slices/modalSlice';
import AppHeader from '../../components/AppHeader/AppHeader';
import FormularioAlterarCadastroTotem from '../../components/FormularioAlterarCadastro/FormularioAlterarCadastroTotem';
import FormularioUsuarioCadastro from '../../components/FormularioUsuarioCadastro/FormularioUsuarioCadastro';
import FormularioUsuarioCadastroTotem from '../../components/FormularioUsuarioCadastro/FormularioUsuarioCadastroTotem';
import ModalBairro from '../../components/ModalBairro/ModalBairro';
import ModalComoSoube from '../../components/ModalComoSoube/ModalComoSoube';
import ModalContato from '../../components/ModalContato/ModalContato';
import ModalEnquete from '../../components/ModalEnquete/ModalEnquete';
import ModalEscolaridade from '../../components/ModalEscolaridade/ModalEscolaridade';
import ModalEscolhaLoginTotem from '../../components/ModalEscolhaLoginTotem/ModalEscolhaLoginTotem';
import ModalLogin from '../../components/ModalLogin/ModalLogin';
import ModalLoginTotem from '../../components/ModalLoginTotem/ModalLoginTotem';
import ModalSexo from '../../components/ModalSexo/ModalSexo';
import {
  AppBody, AppBodyTotem, AppFragment, BreadCumbs,
} from '../../styles/base';
import Botao from '../../components/Botao/Botao';

const VisualizarUsuarioTotem = ({ ouvidoria, sic, zeladoria }) => {
  const dadosModal = useSelector(selectModal);
  const dadosLogin = useSelector(selectLogin);

  const dispatch = useDispatch();

  window.onload = () => {
    dispatch(resetarModais());
  };

  const cookie = document.cookie ? document.cookie : null;
  const cookieSeparado = cookie ? cookie.split('&') : null;
  const cookieSelecionado = cookieSeparado ? cookieSeparado.find((elemento) => elemento.startsWith('Id2')) : null;
  const cookieSelecionadoSeparado = cookieSelecionado ? cookieSelecionado.split('=') : null;
  const cookieId = cookieSelecionadoSeparado
    ? cookieSelecionadoSeparado[cookieSelecionadoSeparado.length - 1]
    : null;

  if (cookieId) {
    const escolherCidadeCookie = async (Id, Campo) => {
      setCidade({ Id, Campo });
      dispatch(definirCidade({
        idCidade: Id,
        nomeCidade: Campo,
      }));
      await fetchLimparCookie();
      await dispatch(fetchConfiguracoesCidade());
    };

    dispatch(desfazerConexao());
    fetchNomeCidade(cookieId).then((nomeCidade) => escolherCidadeCookie(cookieId, nomeCidade));
  }

  // if (dadosLogin.data) {
  //   return (
  //     <AppFragment
  //       onKeyDown={(e) => {
  //         if (e.key === 'Escape') {
  //           dispatch(resetarModais());
  //         }
  //       }}
  //       tabIndex="0"
  //     >
  //       {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
  //       {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
  //       {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
  //       {dadosModal.modalLoginTotem === 'aberto' && (<ModalLoginTotem />)}
  //       {dadosModal.modalEscolhaLoginTotem === 'aberto' && (<ModalEscolhaLoginTotem />)}
  //       {dadosModal.modalBairro === 'aberto' && (<ModalBairro />)}
  //       {dadosModal.modalSexo === 'aberto' && (<ModalSexo />)}
  //       {dadosModal.modalEscolaridade === 'aberto' && (<ModalEscolaridade />)}
  //       {dadosModal.modalComoSoube === 'aberto' && (<ModalComoSoube />)}
  //       <AppBodyTotem totemCadastro desfoque={dadosModal.desfoque}>
  //         <BreadCumbs>
  //           Você está em:
  //           {' '}
  //           {(ouvidoria) && (<span style={{ fontWeight: 'bold' }}>Ouvidoria</span>)}
  //           {(sic) && (<span style={{ fontWeight: 'bold' }}>Pedido de Informação</span>)}
  //           {' '}
  //           /
  //           {' '}
  //           <span style={{ fontWeight: 'bold' }}>Solicitante</span>
  //         </BreadCumbs>
  //         <FormularioAlterarCadastroTotem />
  //       </AppBodyTotem>
  //     </AppFragment>
  //   );
  // }

  return (
    <AppFragment
      onKeyDown={(e) => {
        if (e.key === 'Escape') {
          dispatch(resetarModais());
        }
      }}
      tabIndex="0"
    >
      {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
      {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
      {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
      {dadosModal.modalLoginTotem === 'aberto' && (<ModalLoginTotem />)}
      {dadosModal.modalEscolhaLoginTotem === 'aberto' && (<ModalEscolhaLoginTotem />)}
      {dadosModal.modalBairro === 'aberto' && (<ModalBairro />)}
      {dadosModal.modalSexo === 'aberto' && (<ModalSexo />)}
      {dadosModal.modalEscolaridade === 'aberto' && (<ModalEscolaridade />)}
      {dadosModal.modalComoSoube === 'aberto' && (<ModalComoSoube />)}
      <>
        <Botao
          onClick={() => document.getElementById('visuddd').scrollBy({
            top: -850,
            left: 0,
            behavior: 'smooth',
          })}
          totemUp
        />
        <Botao
          onClick={() => document.getElementById('visuddd').scrollBy({
            top: 850,
            left: 0,
            behavior: 'smooth',
          })}
          totemDown
        />
      </>
      <AppBodyTotem id="visuddd" totemCadastro desfoque={dadosModal.desfoque}>
        <BreadCumbs>
          Você está em:
          {' '}
          {(ouvidoria) && (<span style={{ fontWeight: 'bold' }}>Ouvidoria</span>)}
          {(sic) && (<span style={{ fontWeight: 'bold' }}>Pedido de Informação (e-SIC)</span>)}
          {(zeladoria) && (<span style={{ fontWeight: 'bold' }}>Zeladoria</span>)}
          {' '}
          &rsaquo;
          {' '}
          <span style={{ fontWeight: 'bold' }}>Criar usuário e senha</span>
        </BreadCumbs>
        {sic && <FormularioUsuarioCadastroTotem sic />}
        {ouvidoria && <FormularioUsuarioCadastroTotem ouvidoria />}
        {zeladoria && <FormularioUsuarioCadastroTotem zeladoria />}
      </AppBodyTotem>
    </AppFragment>

  );
};

VisualizarUsuarioTotem.propTypes = {
  ouvidoria: PropTypes.bool,
  sic: PropTypes.bool,
  zeladoria: PropTypes.bool,
};

VisualizarUsuarioTotem.defaultProps = {
  ouvidoria: false,
  sic: false,
  zeladoria: false,
};

export default VisualizarUsuarioTotem;
